//访问趋势
const dark_heading = "#c2c6dc";
export default function echartBar9() {
    return {

        legend: {
            borderRadius: 0,
            orient: "horizontal",
            x: "center",
            data: [
            ],
        },
        grid: {
            left: "0px",
            right: "20px",
            bottom: "0",
            containLabel: true,
        },
        tooltip: {
            show: true,
            backgroundColor: "rgba(0, 0, 0, .8)",

        },

        xAxis: [
            {
                type: "category",
                data: [],
                axisTick: {
                    alignWithLabel: true,
                },
                splitLine: {
                    show: false,
                },
                axisLabel: {
                    color: dark_heading,
                },
                axisLine: {
                    show: true,
                    color: dark_heading,

                    lineStyle: {
                        color: dark_heading,
                    },
                },
            },
        ],
        yAxis: [
            {
                type: "value",

                axisLabel: {
                    color: dark_heading,
                    formatter: "数量{value}",
                },
                axisLine: {
                    show: true,
                    color: dark_heading,

                    lineStyle: {
                        color: dark_heading,
                    },
                },
                splitLine: {
                    show: false,
                    interval: "auto",
                },
            },
        ],

        series: [
            {
                name: "",
                data: [],
                type: "line",
                barGap: 0,
                color: "#33b2df",
                smooth: true,
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowOffsetY: -2,
                        shadowColor: "rgba(0, 0, 0, 0.3)",
                    },
                },
            }
        ],
    }
};